import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import find from 'lodash/find';
import isNil from 'lodash/isNil';
import isFinite from 'lodash/isFinite';

import { push as pushPath } from 'react-router-redux';

import loadsURL from './url';
import { promiseAction } from '~/misc/dispatch';
import create from '~/misc/create';
import { geosearch, selectPlace, updateCriteria as updateGeoCriteria } from '~/modules/geosearch/actions';
import { hookSimilar } from '~/modules/similarLoads/actions';
import apiSearch, { liveSearch } from '~/api/search';
import { getSingleRate } from '~/api/rate'
import { getSpecificIndicator } from '~/api/indicator'
import { getCapacityRatio } from '~/api/ratio';
import { companyBroker } from '~/api/company';
import types from './types';
import * as searchHelper from '~/misc/search';
import * as urls from '~/routing/urls';
import { form2query } from '../../misc/search';
import { getBidsLoads } from '~/modules/bids/actions'
import { modalClose, modalChange } from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
import { getMyBookingsAction } from '../bookings/action';

Object.filter = (obj, predicate) => Object.fromEntries(Object.entries(obj).filter(predicate));
const filterSearchData = (obj) => {
  var checkKeyList = [
    'date',
    'from_name',
    'to_name',
    'dhd',
    'dho',
    'loadSize',
    'weight',
    'length',
    'equipment',
    'dots',
    'limit',
    'sort_by',
    'sort_order'
  ];
  return Object.filter(obj, ([key, value]) => checkKeyList.includes(key)); 
}

const isSearchDataEqual = (searchData,payload) => {
  let filteredSearchData = filterSearchData(searchData)
  let filteredPayload = filterSearchData(payload)
  return isEqual(filteredSearchData,filteredPayload)
}

const searchCriteria = (query, ensureOpened) => (dispatch, getState) => {
  // issure is here 
  const state = getState();
  const payload = searchHelper.coerceQueryTypes(query);
  const stateQuery = searchHelper.coerceQueryTypes(state.loadsSearch.query);

  // wrongly validate compare two object equal or not
  const isSameQuery = isSearchDataEqual(stateQuery, payload);
  const isOpened = state.routing.pathname.startsWith(urls.LOADS) || state.routing.pathname.startsWith(urls.SEARCHLOADS);

  if (isOpened ? !isSameQuery : ensureOpened) {
    // excute this step always?
    dispatch(pushPath(loadsURL(payload)));
  }

  if (isSameQuery) {
   return
  }
  // if search data from state compare with payload is not equal, then refresh search data in state
  dispatch(create(types.SEARCH_CRITERIA, payload));
  
  
};

const prefetchLimit = 200;
const sendSearchQuery = (dispatch, fn, query, getState) =>
  fn(getState, searchHelper.toServerLegacy({
    ...query,
    limit: Math.max(query.limit || 50, prefetchLimit),
  }))
    .then((result) => {
      // no matter is equal or not always refresh data
      // if (!query.isNotCompare && isEqual(getState().loadsSearch.query, query)) {
      //   return null;
      // }
      return result;
    })
    .catch((reason) => (
      isEqual(getState().loadsSearch.query, query)
        ? Promise.reject(reason)
        : Promise.resolve(null))
    );

const updateCriteria = (prefix, result, dispatch, getState) => {
  const queryPart = searchHelper.queryLocation(prefix, result);
  const currentQuery = getState().loadsSearch.query;

  const criteria = { ...currentQuery, ...queryPart };
  dispatch(searchCriteria(criteria));
};

const geoSearchMap = {
  from: 'search:origin-field',
  to: 'search:destination-field',
};

const countries = ['us', 'ca'];

const checkPlace = (currentState) => {
  const country = find(countries,
    (name) => get(currentState, ['search', name, 'list', '0'])
  );

  return get(currentState, ['search', country, 'list', '0']);
};

const getList = (id, value, dispatch, getState) => {
  if (!value) {
    return Promise.resolve();
  }

  const state = getState().geosearch[id] || {};
  const stateCriteria = get(state, 'criteria');

  if (state.selectedPlaceDetails && (state.placeValue.name === value || !stateCriteria || stateCriteria === value)) {
    return Promise.resolve();
  }

  if (stateCriteria !== value || !checkPlace(state)) {
    dispatch(updateGeoCriteria(id, value));
    return dispatch(geosearch(id, value, true));
  }

  return Promise.resolve();
};

const getDetails = (id, dispatch, getState) => () => {
  const currentState = get(getState(), ['geosearch', id]);

  if (currentState.selectedPlaceDetails) {
    return Promise.resolve();
  }

  const country = find(countries,
    (name) => get(currentState, ['search', name, 'list', '0'])
  );

  const place = checkPlace(currentState);

  if (!place) {
    return Promise.resolve();
  }

  return dispatch(selectPlace(id, country, 0));
};

const criteriaName = (name, st) => st ? `${name} state` : name;

const geoSearchLocation = (prefix, query, id, dispatch, getState) => {
  const value = query.name;
  const state = getState().geosearch[id] || {};
  const stateCriteria = isNil(value) ? get(state, 'criteria') : criteriaName(value, query.st);

  if (!stateCriteria) {
    if (get(state, 'criteria') !== stateCriteria) {
      dispatch(updateGeoCriteria(id, stateCriteria));
      return dispatch(geosearch(id, stateCriteria, true)).then(() => Promise.resolve());
    }
    return Promise.resolve();
  }

  return getList(id, stateCriteria, dispatch, getState)
    .then(getDetails(id, dispatch, getState))
    .then(() => {
      const currentState = getState().geosearch[id] || {};
      const place = currentState.selectedPlaceDetails;
      if (!place) {
        dispatch(updateGeoCriteria(id, ''));
      }

      updateCriteria(prefix, place ? currentState.placeValue : { name: '' }, dispatch, getState);
    });
};

const getLocation = (prefix, query, dispatch, getState) =>
  geoSearchLocation(prefix, {
    name: query[`${prefix}_name`],
    st: query[`${prefix}_st`],
  }, geoSearchMap[prefix], dispatch, getState);

const deadheadOfLocation = {
  from: 'dho',
  to: 'dhd',
};

const deadheadValue = (value) => {
  if (isFinite(value)) {
    return value;
  }

  return 200;
};

const checkDeadHead = (prefix, dispatch, getState) => () => {
  const state = getState();

  const deadheadName = deadheadOfLocation[prefix];

  let currentQuery = state.loadsSearch.query;
  const omitDeadhead = !currentQuery[`${prefix}_name`] || currentQuery[`${prefix}_st`];
  // const value = omitDeadhead ? null : deadheadValue(currentQuery[deadheadName]);
  const value = deadheadValue(currentQuery[deadheadName]);

  const criteria = {
    ...currentQuery,
    [deadheadName]: value,
  };
  dispatch(searchCriteria(criteria));
};

const deadheadLimit = 500;
const limitedDeadhead = (value) =>
  value ? Math.min(value, deadheadLimit) : value;

const limitDeadhead = (query) => ({
  ...query,
  dho: limitedDeadhead(query.dho),
  dhd: limitedDeadhead(query.dhd),
});

const composeQuery = (query, state) => {

  const origin = !query.hasOwnProperty('from_name') && get(state, 'geosearch.search:origin-field.placeValue');
  const destination = !query.hasOwnProperty('to_name') && get(state, 'geosearch.search:destination-field.placeValue');

  return searchHelper.ensureQueryDefaults(limitDeadhead({
    ...query,
    ...searchHelper.checkLocations(origin, destination, query.dho, query.dhd),
  }));
};

const completeCriteria = (query) => (dispatch, getState) => {
  let data = composeQuery(query, getState());
  dispatch(searchCriteria(data, true));

  return promiseAction(dispatch, getState,
    types.LOADS_CRITERIA_COMPLETED,
    Promise.all([
      getLocation('from', query, dispatch, getState)
        .then(checkDeadHead('from', dispatch, getState)),
      getLocation('to', query, dispatch, getState)
        .then(checkDeadHead('to', dispatch, getState)),
    ]).then(() => getState().loadsSearch.query)
  );
};

const searchCreator = (TYPE) => (query) => (dispatch, getState) => {
  // get Bookings and Bids loads.
  if ([types.LOADS_SEARCH, types.LOADS_SORT].includes(TYPE)) {
    dispatch(getMyBookingsAction())
    dispatch(getBidsLoads())
  }
  if ((query.from_lng && query.from_lat) || (query.to_lng && query.to_lat)) {
    (query.from_lng && query.from_lat) && dispatch(updateGeoCriteria('search:origin-field', query.from_name));
    (query.to_lng && query.to_lat) && dispatch(updateGeoCriteria('search:destination-field', query.to_name));
    let data = composeQuery(query, getState());
    // if is not equal then store newest search form data via searchCriteria method
    dispatch(searchCriteria(data, true));
    return promiseAction(
      dispatch,
      getState,
      TYPE,
      dispatch(completeCriteria(query)).then(() => {
        return sendSearchQuery(dispatch, apiSearch, query, getState)
          .then(res => {
            dispatch(create(TYPE, res));
          })
          .catch(error => {
            const { status } = error.response;
            if (status === 423) {
              dispatch(modalChange(modes.REFRESH_HINTS, { type: 'askPop' }));
            }
          });
      })
    );
  } else {
    return promiseAction(dispatch, getState, TYPE, dispatch(completeCriteria(query)).then(() => {
      const state = getState();
      return sendSearchQuery(dispatch, apiSearch, state.loadsSearch.query, getState).catch(error => {
        const { status } = error.response;
        if (status === 423) {
          dispatch(modalChange(modes.REFRESH_HINTS, { type: 'askPop' }))
        }
      })
    }));
  }
}


const fetchMore = searchCreator(types.LOADS_MORE);

export const loadsSearchDriectly = (query) => (dispatch, getState) =>  {
  dispatch(getMyBookingsAction())
  dispatch(getBidsLoads())
  return sendSearchQuery(dispatch, apiSearch, query, getState).then(res => {
    dispatch(create(types.LOADS_SEARCH, res));
    dispatch(searchCriteria(query, false))
  })
}

export const loadsSortDirectly = (query) => (dispatch, getState) => {
  dispatch(getMyBookingsAction())
  dispatch(getBidsLoads())
  const data = searchHelper.toServerLegacy({
    ...query,
  })
  console.log(data);
  return sendSearchQuery(dispatch, apiSearch, query, getState).then(res => {
    dispatch(create(types.LOADS_SORT, res));
    dispatch(searchCriteria(query, false))
  })
}


export const loadsSearchAction = hookSimilar(searchCreator(types.LOADS_SEARCH), {allowTracking: true});
export const loadsSort = hookSimilar(searchCreator(types.LOADS_SORT));

export const loadsMore = (query) => (dispatch) => {
  if (query.limit > prefetchLimit) {
    dispatch(fetchMore(query));
  }

  dispatch(completeCriteria(query)).then(() => dispatch(create(types.LOADS_LIST_LIMIT_CHANGED)));
};


export const loadsSearchRefresh = () => (dispatch, getState) => {
  const state = getState();

  return promiseAction(
    dispatch, getState,
    types.LOADS_REFRESHED,
    sendSearchQuery(
      dispatch,
      (getState2, query) => liveSearch(getState2, query, state.loadsSearch.search_since),
      state.loadsSearch.query,
      getState
    )
  );
};
const refresh = (getState, dispatch) => {
  const arr = getState().loadsSearch.originalList;
  const total = getState().loadsSearch.total;
  if (total > 200 && !arr.length) {
    const formData = getState().loadsSearch.query;
    dispatch(loadsSearch(form2query(formData)));
  }
};
export const loadsHideTheCompany = (data) => (dispatch, getState) => {
  const payload = { data, idType: 'id' };
  dispatch(create(types.HIDE_THE_LOADS, payload));
  setTimeout(() => {
    refresh(getState, dispatch);
  }, 0);
};
// broker-save
export const loadsCollectionTheCompany = (data) => (dispatch, getState) => {
  const payload = data;
  dispatch(create(types.LOADS_COLLECTION_THE_COMPANY, payload));
  companyBroker(getState, { id: data.id, company: data.company, operate: 'save' })
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.LOADS_COLLECTION_THE_COMPANY, payload));
      } else if (response.code === 500) {
        dispatch(create(types.LOADS_NO_COLLECTION_COMPANY, payload));
      }
    }, () => {
      dispatch(create(types.LOADS_NO_COLLECTION_COMPANY, payload));
    });
};
// broker-no-save
export const loadsNoCollectionCompsny = (data) => (dispatch, getState) => {
  const payload = data;
  dispatch(create(types.LOADS_NO_COLLECTION_COMPANY, payload));
  companyBroker(getState, { id: data.id, company: data.company, operate: 'remove' })
    .then(response => {
      if (response.code === 200) {
        dispatch(create(types.LOADS_NO_COLLECTION_COMPANY, payload));
      } else if (response.code === 500) {
        dispatch(create(types.LOADS_COLLECTION_THE_COMPANY, payload));
      }
    }, () => {
      dispatch(create(types.LOADS_COLLECTION_THE_COMPANY, payload));
    });
};
// broker-hide
export const lodasHideBroker = (data) => (dispatch, getState) => {
  companyBroker(getState, { id: data.id, company: data.company, operate: 'hide' })
    .then(() => {
      const payload = { data, idType: 'broker_id' };
      dispatch(create(types.HIDE_THE_COMPANY, payload));
      setTimeout(() => {
        refresh(getState, dispatch);
      }, 0);
    });
};

// checked
export const loadCheck = (id) => create(types.LOADS_CHECKED, { id });

// checkedAll
export const loadCheckedAll = () => (dispatch) => {
  dispatch({ type: types.LOADS_CHECKED_ALL });
};

// clear
export const clearChecked = () => (dispatch) => {
  dispatch({ type: types.CLEAR_CHECKED });
};

export const updateChecked = () => (dispatch) => {
  dispatch({ type: types.UPDATE_CHECKED });
};

export const getAverageRate = ({ equipment, from, to, id }) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.LOADS_UPDATE,
  getSingleRate(getState, { equipment, from, to, id }),
  { id }
)
export const getSpecificIndicatorData = ({ equipment, pickUp, dropOff }) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.LOADS_INDICATOR_DATA,
  getSpecificIndicator(getState, { equipment, pickUp, dropOff })
)
export const getCapacityRatioData = ({ equipment, from, to }) => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.LOADS_CAPACITY_RATIO,
  getCapacityRatio(getState, { equipment, state: [from,to] }),
)


// WEBPACK FOOTER //
// ./src/modules/loadsSearch/actions.js